import { Box } from '@wix/design-system';
import React from 'react';
export const ProductCardSeparator = ({ color = 'gray', height = '1px', width = '100%', ...props }) => {
    return (React.createElement(Box, { width: width, height: height, ...props, backgroundColor: color, borderColor: color, align: "center" }));
};
//# sourceMappingURL=ProductCardSeparator.js.map